var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box",class:{
         'is-dark': _vm.$themeDark,
         'has-text-light': _vm.$themeDark,
         'is-black': _vm.black,
         'is-flat': _vm.flat,
       },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }